import React, { Component } from "react";
import contentify from "../../content/Contentify";
import Store from "../../content/Store";
// import TextInput from "../shared/form/TextInput";
import TextInputMfa from "../shared/form/TextInputMfa";
// import InternalViewButton from "./../shared/buttons/InternalViewButton";
import { connect } from "react-redux";
import { addAPlan } from "../../actions/addaplan/addAPlanActions";
import commonStyles from "../../assets/css/modules/myprofile/change-profile-common.css";
import { Link, withRouter } from "react-router-dom";
import { Paths } from "../../constants/UrlConstants";
import Content from "../../content/Content";
import DisplayValidationErrorsMfa from "../shared/DisplayValidationErrorsMfa";
import Extensions from "./../../validations/Extensions";
import { MembershipNumberValidation } from "./../../validations/MembershipNumberValidation";
import { AddAPlanValidationStatus } from "./../../constants/Constants";
import AddAPlanSuccess from "./AddAPlanSuccess";
import { Redirect } from "react-router";
import styles from "../../assets/css/modules/myprofile/add-a-plan.css";
import { setIsUserOnboarding } from "../onboarding/onboardingActions";
import InternalViewButtonMfa from "../shared/buttons/internalViewButtonMfa";


const mapStateToProps = (state) => {
  const selectedPolicy =
    state.policyReducer && state.policyReducer.selectedPolicy;
  return {
    Layout: state.layoutReducer && state.layoutReducer.layout,
    PhoneNumber:
      state.policyReducer &&
      selectedPolicy &&
      selectedPolicy.PolicyServicingTelephones &&
      selectedPolicy.PolicyServicingTelephones.TelephonePolicyServicing,

    IsInternational: selectedPolicy && selectedPolicy.IsInternational
  };
};

export class AddAPlanMfa extends Component {
  static content = Store.AddAPlan;

  constructor(props) {
    super(props);
    this.membershipNumberOnChange = this.membershipNumberOnChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.validate = this.validate.bind(this);
    this.state = {
      membershipNumber: "",
      validationErrors: [],
      addPlanSuccess: false,
      addedPolicy: null
    };
  }

  membershipNumberOnChange(event) {
    this.setState({
      membershipNumber: Extensions.removeWhiteSpace(event.target.value)
    });
  }

  onBackClick = (event) => {
    event.preventDefault();
    this.props.history.goBack();
  };

  validate() {
    let errors = [];
    if (!this.state.membershipNumber) {
      errors.push(Store.AddAPlan.Errors.MembershipNumberRequired);
    } else if (
      MembershipNumberValidation.isValid(
        this.state.membershipNumber,
        this.props.Layout
      ).length > 0
    ) {
      errors.push(Store.AddAPlan.Errors.MembershipNumberInvalid);
    }

    this.setState({
      validationErrors: errors
    });

    return errors;
  }

  onSubmit() {
    if (this.validate().length > 0) {
      return;
    }
    this.setState({
      validationErrors: []
    });
    this.props.addAPlan(this.state.membershipNumber).then((response) => {
      if (typeof response === "object") {
        if (
          response.message ===
            AddAPlanValidationStatus.AddPlanSuccessForNoAccessPolicy ||
          response.message ===
            AddAPlanValidationStatus.AddPlanSuccessForMovedToAxaHealth
        ) {
          this.props.setIsUserOnboarding({ isUserOnboarding: true });
          this.props.history.push(Paths.HomeContactPreference);
        } else if (
          response.message === AddAPlanValidationStatus.AddPlanSuccess
        ) {
          this.setState({
            addPlanSuccess: true,
            addedPolicy: response.policy
          });
        } else {
          this.handleResponseModelState(response.ModelState);
        }
      } else {
        this.setState({
          validationErrors: [Store.GeneralPages.InternalServerError]
        });
      }
    });
  }

  handleResponseModelState = (modelState) => {
    if (typeof modelState !== "object") {
      this.setState({
        validationErrors: [Store.GeneralPages.InternalServerError]
      });
    } else if (modelState[AddAPlanValidationStatus.Error]) {
      this.setState({
        validationErrors: [Store.AddAPlan.Errors.ErrorOccured]
      });
    } else if (modelState[AddAPlanValidationStatus.PlanAlreadyAdded]) {
      this.setState({
        validationErrors: [Store.AddAPlan.Errors.PlanAlreadyAdded]
      });
    } else if (modelState[AddAPlanValidationStatus.PlanAlreadyLinkedToOther]) {
      this.setState({
        validationErrors: [Store.AddAPlan.Errors.PlanAlreadyLinkedToOther]
      });
    }else if (modelState[AddAPlanValidationStatus.PlanAlreadyRegisteredInSF]) {
      this.setState({
        validationErrors: [Store.AddAPlan.Errors.PlanAlreadyRegisteredInSF]
      });
    }
    else if (modelState[AddAPlanValidationStatus.PlanNotLinkedToSameAccountInSF]) {
      this.setState({
        validationErrors: [Store.AddAPlan.Errors.PlanNotLinkedToSameAccountInSF]
      });
    }
    else if (modelState[AddAPlanValidationStatus.RecordNotFoundInSF]) {
      this.setState({
        validationErrors: [Store.AddAPlan.Errors.RecordNotFoundInSF]
      });
    }
    else if(modelState[AddAPlanValidationStatus.UnableToMatchBySystemRecord]){
        this.setState({
            validationErrors: [Store.AddAPlan.Errors.UnableToMatchBySystemRecord]
        });
    }
  };

  render() {
    if (this.props.IsInternational) {
      return <Redirect to={Paths.NotFound} />;
    }

    if (this.state.addPlanSuccess) {
      return (
        <div className={`${commonStyles.changeProfile} ${styles.addAPlan}`}>
          <h1 className={`axa-headline ${styles.title}`}>
            {this.props.content.Title}
          </h1>
          <AddAPlanSuccess
            policy={this.state.addedPolicy}
            onBackClick={this.onBackClick}
          />
        </div>
      );
    }




  return (
        <div className={`${commonStyles.changeProfileMfa} ${styles.addAPlan}`}>

          <div className="back-button back-button-Mfa">
            <Link to="#" onClick={this.onBackClick}>
              <span className="mr-2 left-arrow-back-mfa">←</span>{" "}
              <span className="back-mfa"><Content name={Store.ChangeProfileCommon.BackButtonLabel} /></span>
            </Link>
          </div>
          <br></br>
        <h1 className={`axa-headline ${styles.titlemfa}`}>
          {this.props.content.Title}
        </h1>
        <p1>{this.props.content.Description}</p1>

        <DisplayValidationErrorsMfa errors={this.state.validationErrors} />
        <TextInputMfa
          label={this.props.content.MembershipLabel}
          tooltip={this.props.content.MembershipTooltip}
          inputId="membershipNumber"
          onChange={(event) => this.membershipNumberOnChange(event)}
          inputValue={this.state.membershipNumber}
          placeholder = {this.props.content.MembershipLabel}
          iconToolTipMfa = {this.props.Layout ==="HOL" ? this.props.content.Errors.ToolTipMFA.HOL : this.props.content.Errors.ToolTipMFA.Any}
        />
        <div className={commonStyles.actionButtonsMFA}>
          
          
            <InternalViewButtonMfa
              label={this.props.content.Submit}
              onClick={this.onSubmit}
            />
          
        </div>
      </div>
  );


  }
}

export default withRouter(
  connect(mapStateToProps, { addAPlan, setIsUserOnboarding })(
    contentify(AddAPlanMfa)
  )
);
